import { useCallback } from 'react';

import { useRouter } from 'next/navigation';

import { useNotifications } from 'hooks/notifications';

// The company is loaded by the server layout, which a client-side push to the
// same URL does not re-render — so an unchanged slug needs router.refresh() to
// pick up the saved settings.
export const useHandleCompanySaved = (currentSlug: string) => {
  const router = useRouter();
  const { addNotification } = useNotifications();

  const handleCompanySaved = useCallback(
    (slug: string) => {
      addNotification({ text: 'Workspace settings saved' });

      if (slug === currentSlug) {
        router.refresh();
      } else {
        router.push(`/${slug}`);
      }
    },
    [addNotification, currentSlug, router],
  );

  return { handleCompanySaved };
};
